import { destroyCookie, setCookie as setRawCookie } from 'nookies';
import { ONE_DAY_IN_SECONDS } from '@/constants/cookie';

// Cookie ドメインは NEXT_PUBLIC_ENVIRONMENT ではなく実ホスト(NEXT_PUBLIC_BASE_URL)から導出する。
// idp 環境は ENVIRONMENT=dev だがホストは idp.klew.jp のため、'.dev.klew.jp' を付けると
// ドメイン不一致でブラウザに Cookie を破棄される。dev ファミリー(local.dev.klew.jp / dev.klew.jp)
// のみサブドメイン共有のため親ドメインを付与し、それ以外(idp/stg/prd)はホスト限定にする。
const getAuthConditionCookieDomain = (): string | undefined => {
  try {
    const host = new URL(process.env.NEXT_PUBLIC_BASE_URL).hostname;
    if (host === 'dev.klew.jp' || host.endsWith('.dev.klew.jp')) return '.dev.klew.jp';
    return undefined;
  } catch {
    return undefined;
  }
};

const getAuthConditionCookieOptions = () => {
  const domain = getAuthConditionCookieDomain();
  return domain ? { path: '/', domain } : { path: '/' };
};

export const destroyAuthConditionCookies = () => {
  const cookieOptions = getAuthConditionCookieOptions();
  destroyCookie(null, 'chains_is_email_verified', cookieOptions);
  destroyCookie(null, 'chains_is_registered', cookieOptions);
};

export const persistAuthConditionCookies = () => {
  const cookieOptions = { ...getAuthConditionCookieOptions(), maxAge: ONE_DAY_IN_SECONDS };
  setRawCookie(null, 'chains_is_registered', 'true', cookieOptions);
  setRawCookie(null, 'chains_is_email_verified', 'true', cookieOptions);
};
